import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-geolocation-request-main',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './geolocation-request-main.component.html',
  styleUrls: ['./geolocation-request-main.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeolocationRequestMainComponent {



}
